<template>
  <dash-board-layout :active="8" :fulid="true">
    <div class="verification section-padding mb-80">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center my-5">
          <div class="col-xl-8 col-md-8">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Link a bank account</h4>
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" class="identity-upload">
                  <div class="form-row">
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Account number </label>
                      <input
                        type="text"
                        v-model="bankInfo.accountNumber"
                        class="form-control"
                        placeholder="Bank Account Number"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Account name </label>
                      <input
                        type="text"
                        v-model="bankInfo.accountName"
                        class="form-control"
                        placeholder="This must be the same as your name"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Bank Name </label>
                      <input
                        type="text"
                        v-model="bankInfo.bankName"
                        class="form-control"
                        placeholder="please enter bank name"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2"
                        >Bank Account Number or IBAN
                      </label>
                      <input
                        type="text"
                        v-model="bankInfo.iban"
                        class="form-control"
                        placeholder="please enter Bank Account Number or IBAN"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Bank SWIFT </label>
                      <input
                        type="text"
                        v-model="bankInfo.bankSWIFT"
                        class="form-control"
                        placeholder="Users in the U.S. don't have to provide SWIFT"
                      />
                    </div>
                    <div class="form-group col-xl-6">
                      <label class="mr-sm-2">Routing Number </label>
                      <input
                        type="text"
                        v-model="bankInfo.routingNumber"
                        class="form-control"
                        placeholder="for U.S. domestic banks only"
                      />
                    </div>
                    <!-- <div class="form-group col-xl-12">
                      <img
                        src="../../assets/images/routing.png"
                        alt=""
                        class="img-fluid"
                      />
                    </div> -->

                    <div class="text-center col-12">
                      <router-link
                        to="new_bank_account"
                        class="btn btn-primary mx-2"
                        >Back</router-link
                      >
                      <button type="submit" class="btn btn-success mx-2">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import { add_bank_card } from "../../plugins/api/user_bank_acc"; 
export default {
  components: { DashBoardLayout },
  data() {
    return {
      bankInfo: {
        idempotencyKey: "ff9a1a2e-88b0-4989-b2a7-cea2b6775a01",
        accountName: "",
        accountNumber: undefined,
        routingNumber: undefined,
        iban: undefined,
        bankSWIFT: undefined,
        // billingDetails: {
        //   name: "",
        //   line1: "",
        //   line2: "",
        //   city: "",
        //   district: "",
        //   country: "",
        //   postalCode: "",
        // },
        // bankAddress: {
        //   bankName: undefined,
        //   line1: undefined,
        //   line2: undefined,
        //   city: undefined,
        //   district: undefined,
        //   country: "",
        //   postalCode: undefined,
        // },
      },
      bankInfoAch: {
        idempotencyKey: "f7692055-475d-458c-bc56-cd7f391e14d4",
        plaidProcessorToken: "",
        billingDetails: {
          name: "",
          line1: "",
          line2: "",
          city: "",
          district: "",
          country: "",
          postalCode: "",
        },
        metadata: {
          email: undefined,
          phoneNumber: undefined,
          sessionId: "xxx",
          ipAddress: "172.33.222.1",
        },
      },
    };
  },
  methods: {
    formSubmit() {
      add_bank_card(this.bankInfo).then((res) => {
        if (res.code == 0) {
          this.$alert(
            "Successfully created, please refine your account information next.",
            "Props",
            {
              confirmButtonText: "Enter",
              type: "success",
              showClose: false,
              closeOnClickModal: false,
              callback: (action) => {
                this.$router.push(
                  `/att-bank-address-info?token=${
                    res.data
                  }&c=${encodeURIComponent(
                    this.$cardop.bankCard(this.bankInfo.accountNumber)
                  )}&n=${this.bankInfo.accountName}`
                );
              },
            }
          );
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
  },
};
</script>
